/**
 * Common styles for BrandUnderConstruction component
 */

// Common styles shared across all devices

export const mainContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
};

export const carouselSectionStyles = {
  width: '100%',
};

export const messageSectionStyles = (/* theme */) => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  bgcolor: 'background.paper',
  py: { xs: 4, sm: 6, md: 8 }, // Responsive padding retained here for simplicity
});

export const messageContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const contentWrapperStyles = {
  maxWidth: 600,
  width: '100%',
  textAlign: 'center',
};

export const iconStyles = (/* theme */) => ({
  fontSize: '6rem', // Adjust size as needed
  color: 'primary.main', // Use theme color
  mb: 3,
});

export const titleStyles = (/* theme */) => ({
  fontWeight: 700,
  textAlign: 'center',
  mb: 2,
  color: 'text.primary',
});

export const descriptionStyles = (/* theme */) => ({
  textAlign: 'center',
  maxWidth: '600px',
  mb: 4,
  color: 'text.secondary',
}); 